import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./responsive.css";
import "./dark-mode.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Helmet } from "react-helmet";
import PwaInstallPrompt from "./components/PwaInstallPrompt";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Helmet>
      {/* <title>My Ride App</title> */}
      <link rel="icon" type="image/png" href={`${process.env.PUBLIC_URL}/images/pwa-icon-192.png`} />
    </Helmet>
    <LanguageProvider>
      <App />
      <PwaInstallPrompt />
    </LanguageProvider>
  </React.StrictMode>,
);

// Local webpack must win over a previously cached app. Production still registers the worker.
const host = window.location.hostname;
if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register();
}
